<template>

  <main>
    <div class="main-container">

      <b-alert v-model="error" variant="danger" dismissible>
        {{ msg_alert }}
      </b-alert>

      <h3 class="custom-title text-center text-primary mb-4">Nouvel évènement</h3>

      <!-- Form Evenement -->
      <b-form @submit="onSubmit" id="form_send">
        <b-form-input v-model="form.name" placeholder="Nom"></b-form-input>
        <b-form-input v-model="form.date" placeholder="Date" type="date"></b-form-input>

        <b-form-textarea v-model="form.notes" placeholder="Notes" rows="5" max-rows="10"></b-form-textarea>

        <b-button variant="primary" type="submit">Go!</b-button>
      </b-form>

    </div>
  </main>
</template>

<style scoped lang="scss">

input, textarea {
  margin: 20px 0;
}

</style>

<script>

import {create_evenement} from "@/services/ApiServices";


export default {
  name: 'create-evenement-view',
  props: ['evenement'],
  data() {
    return {
      is_update: false,
      error: false,
      msg_alert: '',
      form: {
        name: '',
        date: '',
        notes: ''
      }
    }
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();

      create_evenement(this.form).then(_ => {
        window.location.href = '/list/evenement';
      }).catch(error => {
        this.error = true;
        this.msg_alert = error.message
      })

    }
  },
  created() {
  }
}

</script>
